import { FC, ReactElement, StrictMode } from 'react';

import { ChatRibbonConnected } from '@pp/core/src/components/chat/chatRibbon/ChatRibbonConnected';
import { SessionBalanceConnected } from '@pp/core/src/components/compliance/SessionBalanceConnected';
import { SlotsLoadingConnected } from '@pp/core/src/components/slots/SlotsLoadingConnected';
import { ToastContainerConnected } from '@pp/core/src/components/toast/ToastContainerConnected';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { BroadcasterCommunicationControllerConnector } from './BroadcasterCommunicationControllerConnector';
import { HighflyerBetLimitsConnected } from './components/betLimits/HighflyerBetLimitsConnected';
import { CrashGameRoot } from './components/crashGameRoot/CrashGameRoot';
import { GameBackgroundConnected } from './components/gameBackground/GameBackgroundConnected';
import { GameGridConnected } from './components/gameGrid/GameGridConnected';
import { helpConfig } from './components/help/HelpConfig';
import { GameKeepAliveManager } from './components/keepalive/GameKeepAliveManager';
import { CrashOverlayConnected } from './components/overlay/CrashOverlayConnected';
import { quickGuideContent } from './components/quickGuideContent/quickGuideContent';
import { HFSettings } from './components/settings/CrashSettings/HFSettings';
import { highflyerTrafficLightConfig } from './components/trafficLight/types';
import { BetIds } from './config/bets';
import { HighflyerCoreTimings } from './config/HighflyerCoreTimings';
import { GameVolumeChannels, soundResources } from './config/sound';
import { tableConfigOptions } from './config/tableConfigParserOptions';
import { translationConfig } from './config/translationConfig';
import { highflyerGameCommunicationControllerConfig } from './controllers/gameCommunication/config';
import { GameStore } from './store/GameStore';

export const Game: FC = (): ReactElement => {
  return (
    <StrictMode>
      <CrashGameRoot
        background={<GameBackgroundConnected />}
        betLimitContent={<HighflyerBetLimitsConnected />}
        config={{
          betConfig: BetIds,
          gameCommunicationConfig: highflyerGameCommunicationControllerConfig,
          gameStore: GameStore,
          helpConfig,
          playAreaSize: 100,
          soundResources,
          translationConfig,
          tableConfigOptions,
          uiVolumeChannel: GameVolumeChannels.Game,
          volumeChannels: GameVolumeChannels,
          defaultTimings: HighflyerCoreTimings,
          trafficLightConfig: highflyerTrafficLightConfig,
          chatConfig: {
            hideDealerName: true,
          },
          featureConfigs: ['core','highflyer'],
          isCrashGame: true,
          isChipless: true,
        }}
        gameSettingsSpecificTab={[{ label: <L10nText tk="SETTINGS_GAME" />, content: <HFSettings /> }]}
        quickGuideContent={quickGuideContent}
        soundControls={[
          {
            channel: GameVolumeChannels.Game,
            label: <L10nText tk="GAMEEFFECTS" />,
            description: <L10nText tk="ADJUST_SOUND_EFFECTS" />,
          },
          {
            channel: GameVolumeChannels.Background,
            label: <L10nText tk="GAME_MUSIC" />,
            description: <L10nText tk="ADJUST_STUDIO_EFFECTS" />,
          },
        ]}
      >
        <BroadcasterCommunicationControllerConnector gameStore={GameStore} />
        <GameKeepAliveManager />
        <GameGridConnected />
        <SessionBalanceConnected />
        <ToastContainerConnected />
        <ChatRibbonConnected />
        <CrashOverlayConnected />
        <SlotsLoadingConnected />
      </CrashGameRoot>
    </StrictMode>
  );
};
